/** Brand purple — matches tailwind `brand-500` / `#B700FA` */
export const NEUNEU_PARTICLE_COLOR = 0xb700fa;
export const NEUNEU_PARTICLE_COUNT = 2000;
export const NEUNEU_SPHERE_RADIUS = 45;
/** Radius of each tetrahedron particle (reference demo: 0.25) */
export const NEUNEU_TETRA_SIZE = 1;

/** HSL lightness per particle (0–1) — higher = brighter on dark UI */
export const NEUNEU_HSL_LIGHT_BASE = 0.3;
export const NEUNEU_HSL_LIGHT_AMP = 0.1;

/** 3D camera (perspective, matching reference demo) */
export const NEUNEU_CAMERA_ZOOM = 3;

/** Avatar layer transition (ms) — keep in sync with CSS duration. */
export const NEUNEU_TRANSITION_MS = 320;

/**
 * Layout reference (Tailwind classes must stay literal in components for JIT):
 * - Fab: h-32 w-32 (128px)
 * - Panel: w-[min(100vw-2rem,28rem)], bottom-36 (avatar stays on fab, not in header)
 */
